import Image from "next/image";

export default function ArchitectureSection() {
  const steps = [
    {
      title: "Failure Detected",
      desc: "Real-time monitoring",
      color: "from-sky-600 to-purple-600",
      icon: "/revinu/e1.png",
    },
    {
      title: "Categorization",
      desc: "AI-powered analysis",
      icon: "/revinu/e2.png",
    },
    {
      title: "Outreach",
      desc: "Personalized messaging",
      icon: "/revinu/e3.png",
    },
    {
      title: "Retry Execution",
      desc: "Smart scheduling",
      icon: "/revinu/e4.png",
    },
    {
      title: "Recovery",
      desc: "Revenue restored",
      color: "from-green-500 to-emerald-600",
      icon: "/revinu/e5.png",
      highlight: true,
    },
  ];

  return (
    <section className="bg-white py-32 px-6 lg:px-20">
      <div className="max-w-[1750px ] mx-auto flex flex-col items-center gap-6">

        {/* Heading */}
        <h2 className="text-4xl lg:text-5xl font-bold text-center text-gray-900">
          Our Payment Recovery Architecture
        </h2>

        <p className="text-lg text-gray-600 text-center max-w-2xl">
          A structured, logic-driven system designed for predictable revenue retention.
        </p>

        {/* Timeline */}
        <div className="w-full pt-14">

          <div className="relative">

            {/* line — centered on the icons (h-20 = 80px, half = 40px = top-10) */}
            <div className="hidden md:block absolute top-10 left-0 right-0 h-1 bg-sky-200 rounded-full -translate-y-1/2"></div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 text-center">

            {steps.map((step, index) => (
              <div key={index} className="flex flex-col items-center gap-4">

                {/* Icon Box */}
                <div
                  className={`relative z-10 w-20 h-20 rounded-2xl flex items-center justify-center font-bold
                  ${
                    step.color
                      ? `bg-gradient-to-br ${step.color} shadow-lg`
                      : "bg-white border-2 border-gray-300"
                  }`}
                >
                  <Image src={step.icon} alt={step.title} width={40} height={40} className="object-contain" />
                </div>

                {/* Title */}
                <h3
                  className={`font-bold text-lg ${
                    step.highlight ? "text-green-600" : "text-gray-900"
                  }`}
                >
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-gray-500">{step.desc}</p>
              </div>
            ))}

          </div>

          </div>{/* end relative */}
        </div>{/* end pt-14 */}
      </div>
    </section>
  );
}
